var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: [
        "section-header",
        ..._vm.variantClassList,
        _vm.hasBorder && "section-header__border"
      ]
    },
    [
      _c("div", { staticClass: "section-header__container" }, [
        _c("div", { staticClass: "section-header__icon-text-container" }, [
          _vm.hasIcon
            ? _c("span", { staticClass: "section-header__icon" }, [
                _c("i", { class: ["icon", _vm.iconClassName] })
              ])
            : _vm._e(),
          _c(
            "span",
            { staticClass: "section-header__text" },
            [
              _vm._t("default", function() {
                return [_vm._v(" " + _vm._s(_vm.sectionText) + " ")]
              })
            ],
            2
          )
        ]),
        _vm.hasButton
          ? _c(
              "span",
              { staticClass: "section-header__button" },
              [_vm._t("btnslot")],
              2
            )
          : _vm._e()
      ]),
      _vm.variant === "textDivider"
        ? _c("Divider", { staticClass: "section-header__divider" })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }